import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Classes, Dialog } from '@blueprintjs/core';
import { AppStore } from '../../stores/AppStore';
import { MDBRow, MDBBtn } from "mdbreact";
import { NotificacoesStore } from '../../stores/notificacoes/NotificacoesStore';
import { IconButton } from '@mui/material';
import { LegislacaoStore } from '../../stores/legislacao/LegislacaoStore';
import { AppIcon } from '../utils/AppIcon';

interface State {
  isTourOpen: boolean,
  isShowingMore: boolean,
  menuItems: MenuItem[];
}

type MenuItem = {
  label: string;
  path: string;
  icon: JSX.Element;
};

@observer
export class DashboardUserPage extends React.Component<{}, State> {

  obs = observable({
    open_visualiza_descricao: false as boolean,
    description: "" as string,
  })

  constructor(props: any) {
    super(props);

    this.state = {
      isTourOpen: false,
      isShowingMore: false,
      menuItems: []
    };

  }

  async componentDidMount() {

    AppStore.setTitle("");

    await NotificacoesStore.handleConsultaWarnings();

    if (NotificacoesStore.obs.warnings.length >= 1) {
      NotificacoesStore.obs.isTourOpen = true
    }

    if (AppStore.obs1.usuario && AppStore.obs1.releases.length) {

      if (!AppStore.obs1.usuario.version_update || AppStore.obs1.usuario.version_update != AppStore.obs1.releases[0].version) {

        this.obs.open_visualiza_descricao = true
        this.obs.description = AppStore.obs1.releases[0].description

      }

    }

  }

  formatVersion = (version) => {

    return parseInt(version.replace(/\./g, ""))

  }

  async handleEntendi() {

    this.obs.open_visualiza_descricao = false

    if (!AppStore.obs1.usuario.version_update || this.formatVersion(AppStore.obs1.releases[0].version) > this.formatVersion(AppStore.obs1.usuario.version_update)) {

      await AppStore.handleUpdatesModal(AppStore.obs1.usuario._id, AppStore.obs1.releases[0].version)

      if (AppStore.obs1.result_ok) {

        await AppStore.loadUsuario()

      }

    }

  }

  async handleLocator(path) {

    if (path == "/calculo-icms") {

      await LegislacaoStore.get_pdf("icms")
      return

    }

    if (path == "/decreto-icms") {

      await LegislacaoStore.get_pdf("decreto")
      return

    }

    AppStore.setLocation(path)

  }

  render() {

    const permissoesRotas = {
      "PGDAS": [{ label: "PGDAS", path: "/pgdas", iconName: "savings" }],
      "SPED": [{ label: "SPED", path: "/sped", iconName: "description" }],
      "FGTS DIGITAL": [{ label: "FGTS DIGITAL", path: "/fgts-digital", iconName: "engineering" }],
      "IMPORTACAO": [{ label: "IMPORTAÇÃO DE XMLS", path: "/imports", iconName: "upload_file" }],
      "XML INTEGRACAO": [{ label: "XML INTEGRAÇÃO", path: "/xml-integration", iconName: "code" }],
      "MANIFESTACAO": [{ label: "MANIFESTAÇÃO", path: "/historico-notas", iconName: "manage_search" }],
      "NOTAS": [{ label: "NF-E | NFC-E | CT-E | NFS-E", path: "/nfes", iconName: "integration_instructions" }],
      "SEFA": [{ label: "SOLICITAÇÕES SEFA", path: "/solicitacoes-sefa", iconName: "support_agent" }],
      "PARAUAPEBAS": [{ label: "PARAUAPEBAS", path: "/nfse-prefeitura", iconName: "home_work" }],
      "MEMORIA DE CALCULOS": [{ label: "MEMÓRIA DE CALCULOS", path: "/memoria-calculo", iconName: "memory" }],
      "RESULTADOS DE CALCULOS": [{ label: "RESULTADOS DE CALCULOS", path: "/resultados", iconName: "calculate" }],
      "LEGISLACAO": [
        { label: "MVAS - PA", path: "/mvas-pa", iconName: "report_problem" },
        { label: "MVAS - RS", path: "/mvas-rs", iconName: "report_problem" },
        { label: "ALÍQUOTAS DE ICMS", path: "/icms-aliquotas", iconName: "percent" },
        { label: "MONOFÁSICO", path: "/monofasico-simples", iconName: "difference" },
        { label: "CST - ORIGEM", path: "/cst-origem", iconName: "settings_suggest" },
        { label: "CST - CSON/ICMS", path: "/cst-cson", iconName: "edit" },
        { label: "CST - PIS/COFINS", path: "/pis-cofins", iconName: "monetization_on" },
        { label: "TRIBUTAÇÃO NACIONAL", path: "/tributacao-nacional", iconName: "attach_money" },
        { label: "CFOPS", path: "/cfops", iconName: "numbers" },
        { label: "TIPI", path: "/tipi", iconName: "table_chart" },
        { label: "CNAE", path: "/cnae", iconName: "production_quantity_limits" },
        { label: "EANS", path: "/eans", iconName: "barcode" },
        { label: "CALCULO ICMS", path: "/calculo-icms", iconName: "download" },
        { label: "DECRETO ICMS", path: "/decreto-icms", iconName: "download" }
      ],
      "CNDS": [{ label: "CNDS", path: "/cnds", iconName: "workspace_premium" }],
      "RELATORIO GERAL": [{ label: "RELATÓRIO GERAL", path: "/relatorios", iconName: "analytics" }],
      "SITFIS": [{ label: "SITUAÇÃO FISCAL (RFB)", path: "/sitfis", iconName: "account_balance" }],
      "DEC SEFA": [{ label: "DEC SEFA", path: "/dec-sefa", iconName: "mark_email_unread" }],
      "CAIXA POSTAL": [{ label: "CAIXA POSTAL", path: "/caixa-postal", iconName: "inbox" }],
      "CLASSIFICACAO": [{ label: "CLASSIFICAÇÃO", path: "/classificacao", iconName: "account_tree" }],
      "PARCELAMENTOS": [{ label: "PARCELAMENTOS", path: "/parcelamentos", iconName: "payments" }],
      "DEI": [{ label: "DEI", path: "/dei", iconName: "assignment" }],
    };

    return (

      <div>

        <MDBRow>

          <div className="container-modulos" style={{ width: "100%", justifyContent: "center" }}>

            {AppStore.obs1.usuario.permissao.map((permissao) =>
              permissoesRotas[permissao]?.map(({ label, path, iconName }) => (
                <div onClick={() => this.handleLocator(path)} key={path} className="itens-menu-fiscal">
                  <div className="mb-2"><AppIcon name={iconName} size={24} /></div>
                  {label}
                </div>
              ))
            )}

          </div>

        </MDBRow>

        <div style={{ marginTop: 5, marginBottom: 100 }}></div>

        <Dialog isOpen={this.obs.open_visualiza_descricao} onClose={() => this.obs.open_visualiza_descricao = false} className="modal-releases">

          <div className={Classes.DIALOG_CLOSE_BUTTON} style={{ textAlign: "right" }}>
            <IconButton onClick={() => AppStore.setLocation("/releases")}>
              <AppIcon name="arrow_forward" style={{ color: "#3579ea" }} />
            </IconButton>
          </div>

          <div style={{ padding: "0px 0px 15px 0px" }}>

            <div dangerouslySetInnerHTML={{ __html: this.obs.description }} />

          </div>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <MDBBtn className="btnDefault" onClick={() => this.obs.open_visualiza_descricao = false}>Fechar</MDBBtn>
            &nbsp;&nbsp;
            <MDBBtn className="btnDefault btnNaoMostrar" onClick={() => this.handleEntendi()}>Entendi</MDBBtn>
          </div>

        </Dialog>

      </div>

    );
  }
}

export default DashboardUserPage;

